/**
 * src/components/platform/Platform.js
 *
 * Componente padre de la sección plataforma.
 * Orquesta PlatformHeader y FeatureGrid con datos de platform.db.js.
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { platformData } from '@/db/platform.db.js'

define('Platform', () => {
    return h('section', { className: 'platform' },
        h('div', { className: 'platform__inner' },
            c('PlatformHeader', platformData.section),
            c('FeatureGrid',    { features: platformData.features })
        )
    )
})
